module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("用户解绑")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('img', {
    staticClass: "unbind-img",
    attrs: {
      "src": require("./unbind.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("是否确认解绑")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unbind
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('button', {
    staticClass: "btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelBind
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-296a79b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wechat/unbind.vue
// module id = 340
// module chunks = 1